import React from "react";
import { Form } from "rsuite";

const TemporaryAddress = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Province</Form.ControlLabel>
        <Form.Control name="Province" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>District</Form.ControlLabel>
        <Form.Control name="District" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Municipality</Form.ControlLabel>
        <Form.Control name="Municipality" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Temporary Street Name</Form.ControlLabel>
        <Form.Control name="TemporaryStreetName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Temporary Street Name (Nepali)</Form.ControlLabel>
        <Form.Control name="TemporaryStreetName(Nepali)" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Temporary House No.</Form.ControlLabel>
        <Form.Control name="TemporaryHouseNo" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Temporary Ward No.</Form.ControlLabel>
        <Form.Control name="TemporaryWardNo" type="number" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Temporary Location</Form.ControlLabel>
        <Form.Control name="TemporaryLocation" />
      </Form.Group>
    </div>
  );
};

export default TemporaryAddress;
